// Runtime configuration. Populated at app boot by main.jsx with values that vary by
// stage (sandbox vs prod) — never embed secrets here; only public endpoints and IDs.

/**
 * @typedef {Object} KanjoConfig
 * @property {string} apiBaseUrl        - API Gateway base URL (no trailing slash).
 * @property {string} cognitoDomain     - Cognito hosted-UI domain (https://....auth.<region>.amazoncognito.com).
 * @property {string} cognitoClientId   - App client ID (public).
 * @property {string} cognitoRegion     - e.g. "us-west-2".
 * @property {string} cognitoUserPoolId - e.g. "us-west-2_abc123".
 * @property {string} cognitoIssuer     - "https://cognito-idp.<region>.amazonaws.com/<userPoolId>".
 * @property {string} cognitoJwksUrl    - "<issuer>/.well-known/jwks.json".
 * @property {string} stage             - "sandbox" | "prod".
 * @property {string} redirectUri       - OAuth redirect (must match Cognito app client).
 */

/** @type {KanjoConfig | null} */
let cfg = null;

/** @param {KanjoConfig} c */
export function configure(c) {
  if (!c || typeof c !== 'object') throw new Error('configure: missing config');
  for (const k of [
    'apiBaseUrl', 'cognitoDomain', 'cognitoClientId', 'cognitoRegion',
    'cognitoUserPoolId', 'cognitoIssuer', 'cognitoJwksUrl', 'stage', 'redirectUri',
  ]) {
    if (typeof c[k] !== 'string' || !c[k]) throw new Error(`configure: missing "${k}"`);
  }
  if (!/^https:\/\//.test(c.apiBaseUrl) && c.stage === 'prod') {
    throw new Error('configure: apiBaseUrl must be HTTPS in prod');
  }
  cfg = Object.freeze({ ...c });
}

/** @returns {KanjoConfig} */
export function getConfig() {
  if (!cfg) throw new Error('kanjo.configure(...) has not been called');
  return cfg;
}
